export default __webpack_public_path__ + "0ddd2171b4971678c2eda39cb8bc1c52.png";